module.exports = __webpack_public_path__ + "media/images/debt_consol_icon_inactive-64f21ea0.svg";